(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var singletonKey = '__gwpHextomTopBarMount';

    if (window[singletonKey]) {
      window[singletonKey].sync();
      return;
    }

    var queued = false;

    function syncSelector() {
      queued = false;

      var mount = document.querySelector('[data-gwp-hextom-mount]');
      var selector = document.querySelector('.header-section #search .ht-tms__duo-selector') ||
        document.querySelector('.ht-tms--float .ht-tms__duo-selector') ||
        document.querySelector('.ht-tms__duo-selector');

      if (!mount || !selector) return;

      var source = selector.closest('#search[data-injected="true"], .ht-tms--float') || selector;

      if (source.parentElement !== mount) {
        mount.appendChild(source);
      }

      source.classList.add('gwp-hextom-mounted');
      source.classList.remove(
        'ht-tms--float-top',
        'ht-tms--float-bottom',
        'ht-tms--float-left',
        'ht-tms--float-right',
        'ht-tms-position-on-page--bottom',
        'ht-tms-position-on-page--left'
      );
      selector.classList.remove(
        'ht-tms-position-on-page--bottom',
        'ht-tms-position-on-page--left'
      );
      selector.classList.add(
        'ht-tms-position-on-page--top',
        'ht-tms-position-on-page--right'
      );

      var trigger = selector.querySelector('.ht-tms__duo-selector__active-item');

      if (trigger && !trigger.hasAttribute('data-gwp-keyboard-ready')) {
        var activeValue = (trigger.getAttribute('data-value') || '').split(',')[0];
        var activeLanguage = (trigger.textContent || '').trim();

        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-label', [activeValue, activeLanguage].filter(Boolean).join(', '));
        trigger.setAttribute('data-gwp-keyboard-ready', 'true');

        function updateExpandedState() {
          trigger.setAttribute(
            'aria-expanded',
            selector.classList.contains('ht-tms__duo-selector--open') ? 'true' : 'false'
          );
        }

        var stateObserver = new MutationObserver(updateExpandedState);
        stateObserver.observe(selector, { attributes: true, attributeFilter: ['class'] });
        trigger.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            trigger.click();
          } else if (
            event.key === 'Escape' &&
            selector.classList.contains('ht-tms__duo-selector--open')
          ) {
            event.preventDefault();
            trigger.click();
          }
        });
      }
    }

    function queueSync() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(syncSelector);
    }

    var observer = new MutationObserver(queueSync);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-injected']
    });

    document.addEventListener('shopify:section:load', queueSync);
    window[singletonKey] = { observer: observer, sync: queueSync };
    queueSync();
  })();

  } catch(e) { console.error(e); }
})();
})();
